import { render, staticRenderFns } from "./LinkItemParts.vue?vue&type=template&id=1fd5a5cc&scoped=true"
import script from "./LinkItemParts.vue?vue&type=script&lang=ts"
export * from "./LinkItemParts.vue?vue&type=script&lang=ts"
import style0 from "./LinkItemParts.vue?vue&type=style&index=0&id=1fd5a5cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd5a5cc",
  null
  
)

export default component.exports